// extracted by mini-css-extract-plugin
export default {"about":"about_about__j-Jtn","about__heading":"about_about__heading__pex9F","about__hr":"about_about__hr__9Mq5C","about__main":"about_about__main__ncg2Q"};